// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"f36f7616","379":"4e24ce86","464":"a69240c5","819":"782e1c5b","930":"3884c320"}[chunkId] + ".chunk.css";
};